module.exports = {"231283100":"海伦镇","231283101":"海北镇","231283102":"伦河镇","231283103":"共合镇","231283104":"海兴镇","231283105":"祥富镇","231283106":"东风镇","231283107":"百祥镇","231283108":"向荣镇","231283109":"永富镇","231283110":"长发镇","231283111":"联发镇","231283112":"前进镇","231283113":"共荣镇","231283205":"东林乡","231283208":"海南乡","231283210":"乐业乡","231283211":"福民乡","231283212":"丰山乡","231283217":"永和乡","231283218":"爱民乡","231283220":"扎音河乡","231283221":"双录乡","231283400":"林场公司","231283401":"东方红水库地区","231283500":"海伦农场","231283501":"红光农场","231283581":"海伦市董家农作物种植场","231283582":"海伦市东方农牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231283.json
// module id = 800
// module chunks = 0